<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card style="height: calc(100vh - 80px)">
          <q-card-section v-if="!selectedEvent">
            <div class="row items-center">
              <div
                style="display: inline-block"
                class="text-h6"
                v-if="competition"
              >
                <q-btn
                  icon="mdi-arrow-left"
                  @click="$router.push('/')"
                  dense
                  flat
                ></q-btn>
                {{ competition.competition_name }}
              </div>
              <!-- <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-refresh"
              >
              </q-btn> -->
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section class="q-pa-none" v-if="!selectedEvent">
            <q-tabs v-model="tab" class="text-black">
              <q-tab name="eventBrackets" label="Results" />
              <q-tab
                name="pointsTable"
                label="Points"
                v-if="
                  competition.lr_showPoints &&
                    (!competition.lr_showPAndMAfterFinished ||
                      $moment() > competition.end_date)
                "
              />
              <q-tab
                name="medalsTable"
                label="Medals"
                v-if="
                  competition.lr_showMedals &&
                    (!competition.lr_showPAndMAfterFinished ||
                      $moment() > competition.end_date)
                "
              />
            </q-tabs>
            <div class="q-pa-sm full-width" v-if="tab == 'eventBrackets'">
              <div class="row q-col-gutter-sm">
                <div class="col-6">
                  <q-btn
                    label="Filter Events"
                    dense
                    class="full-width"
                    color="primary"
                    no-caps
                  >
                    <q-menu>
                      <div class="row q-pa-md">
                        <div class="col-12">
                          <div class="text-h6 q-mb-none">Filters</div>
                        </div>
                        <div class="col-12 q-mb-sm">
                          <q-input
                            label="Search Event Name"
                            v-model="filter.search"
                          ></q-input>
                        </div>
                        <div class="col-12 q-mb-sm">
                          <autocomplete
                            label="Filter by Division"
                            :items="divisions"
                            :itemsLoading="divisionsLoading"
                            option_label="division_name"
                            option_value="id"
                            :id="filter.division_id"
                            clearable
                            @changed="
                              val => {
                                filter.division_id = val;
                              }
                            "
                          />
                        </div>
                        <div class="column">
                          <q-checkbox
                            v-model="filter.registration"
                            size="sm"
                            label="Registration"
                          />
                          <q-checkbox
                            v-model="filter.drawingLanes"
                            size="sm"
                            label="Drawing Lanes"
                          />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column">
                          <q-checkbox
                            v-model="filter.eventInProgress"
                            size="sm"
                            label="In Progress"
                          />
                          <q-checkbox
                            v-model="filter.finished"
                            size="sm"
                            label="Finished"
                          />
                        </div>
                      </div>
                    </q-menu>
                  </q-btn>
                </div>
                <div class="col-6">
                  <q-btn
                    label="Search"
                    dense
                    class="full-width"
                    color="primary"
                    no-caps
                  >
                    <q-menu>
                      <div class="row q-pa-md">
                        <div class="col-12">
                          <div class="text-h6 q-mb-none">
                            Search for Athlete or Club
                          </div>
                        </div>
                        <div class="col-12 q-mb-sm">
                          <athleteAndAssociationSearch
                            clearable
                            :id="selectedAthleteOrAssociation_id"
                            :data="athleteAndAssociationList"
                            :loading="athleteAndAssociationListLoading"
                            @changed="filterAthleteAssociation"
                          />
                        </div>
                      </div>
                    </q-menu>
                  </q-btn>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="tab == 'pointsTable'" class="q-pa-none">
            <div v-if="overallPoints">
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 230px) !important"
                >
                  <datatable
                    :filter="overallPointsFilter.search"
                    :flat="true"
                    :data="overallPoints"
                    :columns="overAllPointsColumn"
                    @rowDoubleClick="handleDoubleClickOverallPoints"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.rowIndex + 1 }}</b>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-association_abbr"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-img
                          v-if="data.props.row.capUrl"
                          :src="data.props.row.capUrl"
                          style="width: 40px"
                          contain
                        >
                        </q-img>
                        <q-img
                          v-else
                          src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
                          style="width: 40px"
                          contain
                          class="q-ml-sm float-right"
                        >
                        </q-img>
                        {{ data.props.row.association_abbr }}
                      </q-td>
                    </template>
                    <template slot="body-cell-points" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.row.points }}</b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="tab == 'medalsTable'" class="q-pa-none">
            <div v-if="overallMedals">
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  style="height: calc(100vh - 230px) !important"
                >
                  <datatable
                    :filter="overallMedalsFilter.search"
                    :flat="true"
                    :data="overallMedals"
                    :columns="overAllMedalsColumn"
                    @rowDoubleClick="handleDoubleClickOverallMedals"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.rowIndex + 1 }}</b>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-association_abbr"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <q-img
                          v-if="data.props.row.capUrl"
                          :src="data.props.row.capUrl"
                          style="width: 40px"
                          contain
                        >
                        </q-img>
                        <q-img
                          v-else
                          src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
                          style="width: 40px"
                          contain
                          class="q-ml-sm float-right"
                        >
                        </q-img>
                        {{ data.props.row.association_abbr }}
                      </q-td>
                    </template>
                    <template slot="body-cell-medals" slot-scope="data">
                      <q-td :props="data.props">
                        <b>{{ data.props.row.medals }}</b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section v-if="tab == 'eventBrackets'" class="q-pa-none">
            <div v-show="!selectedEvent">
              <div class="row q-py-xs items-center">
                <q-btn
                  @click="stepFilter = null"
                  icon="mdi-close"
                  size="sm"
                  flat
                  round
                >
                </q-btn>
                <q-card
                  @click.prevent="stepFilter = 0"
                  :class="
                    `col q-pa-xs q-mx-xs bg-${
                      stepFilter == 0 ? 'white' : eventProgressionColor(0)
                    } text-${
                      stepFilter == 0 ? eventProgressionColor(0) : 'white'
                    }  text-center`
                  "
                  :flat="stepFilter == 0"
                >
                  To be held
                </q-card>
                <q-card
                  @click.prevent="stepFilter = 2"
                  :class="
                    `col q-pa-xs q-mx-xs bg-${
                      stepFilter == 2 ? 'white' : eventProgressionColor(2)
                    } text-${
                      stepFilter == 2 ? eventProgressionColor(2) : 'white'
                    }  text-center`
                  "
                  :flat="stepFilter == 2"
                >
                  Active
                </q-card>
                <q-card
                  @click.prevent="stepFilter = 3"
                  :class="
                    `col q-pa-xs q-mx-xs bg-${
                      stepFilter == 3 ? 'white' : eventProgressionColor(3)
                    } text-${
                      stepFilter == 3 ? eventProgressionColor(3) : 'white'
                    }  text-center`
                  "
                  :flat="stepFilter == 3"
                >
                  Finished
                </q-card>
              </div>
              <div
                class="row items-center text-bold text-center"
                v-if="selectedAthleteOrAssociation"
              >
                <div class="col-12">
                  <q-img
                    :src="selectedAthleteOrAssociation.capUrl"
                    style="width: 50px"
                  ></q-img>
                  {{ selectedAthleteOrAssociation.firstName }}
                  {{ selectedAthleteOrAssociation.lastName }}
                </div>
              </div>
              <div class="row">
                <div
                  class="col-12 mt-0 pt-0"
                  :style="
                    `height: calc(100vh - ${
                      selectedAthleteOrAssociation ? '363px' : '313px'
                    }) !important`
                  "
                >
                  <datatable
                    :filter="''"
                    :flat="true"
                    :data="
                      eventsFiltered.sort((a, b) => {
                        if (competition.preDrawnEvents) {
                          return a.event_no - b.event_no;
                        }

                        if (a.lane_updated_at && b.lane_updated_at) {
                          return (
                            new Date(b.lane_updated_at) -
                            new Date(a.lane_updated_at)
                          );
                        }

                        if (!a.lane_updated_at && b.lane_updated_at) {
                          return 1;
                        }

                        if (a.lane_updated_at && !b.lane_updated_at) {
                          return -1;
                        }

                        return 0;
                      })
                    "
                    :columns="eventColumns"
                    @rowSelected="handleDoubleClickEvents"
                  >
                    <template slot="body-cell-eventName" slot-scope="data">
                      <q-td :props="data.props">
                        <div class="row items-center">
                          <div
                            v-if="
                              selectedAthleteOrAssociation &&
                                !selectedAthleteOrAssociation.type
                            "
                            class="col-auto"
                            style="width: 50px"
                          >
                            <b>{{
                              data.props.row.placings[0]
                                ? data.props.row.placings[0].placing
                                : "TBD"
                            }}</b>
                          </div>
                          <div class="col">
                            <b>
                              {{ data.props.row.event_name }}
                            </b>
                            <p style="font-size: 10px" class="q-my-none">
                              {{
                                data.props.row.individualEntries > 0
                                  ? `${data.props.row.individualEntries} athletes`
                                  : data.props.row.teamEntries > 0
                                  ? `${data.props.row.teamEntries} teams`
                                  : ""
                              }}
                              <q-chip
                                :color="
                                  eventProgressionColor(
                                    data.props.row.currentStep
                                  )
                                "
                                square
                                class="text-white text-center float-right"
                                style="font-size: 12px"
                                dense
                              >
                                {{
                                  data.props.row.currentStep == 0
                                    ? "To be held"
                                    : data.props.row.currentStep == 1
                                    ? "To be held"
                                    : data.props.row.currentStep == 2
                                    ? "Active"
                                    : "Finished"
                                }}
                              </q-chip>
                            </p>
                          </div>
                        </div>
                      </q-td>
                    </template>
                    <template
                      slot="body-cell-eventProgression"
                      slot-scope="data"
                    >
                      <q-td :props="data.props">
                        <b>
                          {{
                            data.props.row.currentStep == 0
                              ? "Registration"
                              : data.props.row.currentStep == 1
                              ? "Drawing Lanes"
                              : data.props.row.currentStep == 2
                              ? "Event In Progress"
                              : "Finished"
                          }}
                        </b>
                      </q-td>
                    </template>
                  </datatable>
                </div>
              </div>
            </div>
            <q-scroll-area
              v-if="selectedEvent"
              style="height: calc(100vh - 100px) !important; width: 100%"
            >
              <div style="display: inline-block" class="text-h6 q-mt-md">
                <q-btn
                  icon="mdi-arrow-left"
                  flat
                  @click="selectedEvent = null"
                ></q-btn>
                {{ selectedEvent.event_name }}
              </div>
              <div v-if="event" class="container">
                <div class="tournament-bracket tournament-bracket--rounded">
                  <!-- Rounds -->
                  <div
                    v-for="(round, roundIndex) in event.brackets"
                    :key="`round_${roundIndex}`"
                    class="tournament-bracket__round"
                    :style="
                      `${
                        $q.screen.gt.sm
                          ? 'max-width: 400px; min-width: 400px'
                          : ''
                      }`
                    "
                  >
                    <h3
                      class="tournament-bracket__round-title text-black"
                      style="font-weight: bold"
                    >
                      {{
                        round.round_name.includes("Round")
                          ? round.round_name
                          : round.round_name.replace(/[0-9]/g, "")
                      }}
                    </h3>
                    <ul
                      class="tournament-bracket__list"
                      :class="{
                        noMoreEvents: roundIndex == event.brackets.length - 1
                      }"
                    >
                      <li
                        v-for="(race, raceIndex) in round.races"
                        :key="`race_${raceIndex}`"
                        class="tournament-bracket__item"
                        :class="{
                          notBracket: !round.is_final,
                          bracketStart:
                            event.brackets[roundIndex - 1] &&
                            !event.brackets[roundIndex - 1].is_final,
                          singlePassthrough:
                            event.brackets[roundIndex + 1] &&
                            event.brackets[roundIndex + 1].races.length ==
                              round.races.length
                        }"
                        v-if="
                          race.ce_overallFinal == 0 &&
                            (race.ce_events_id == 0 ||
                              race.ce_events_id == selectedEvent.id)
                        "
                      >
                        <div
                          class="tournament-bracket__match"
                          style="background: #f7fafc"
                          tabindex="0"
                        >
                          <table class="tournament-bracket__table">
                            <caption
                              class="tournament-bracket__caption text-black"
                            >
                              {{
                                round.round_name.includes("Round")
                                  ? "Heat"
                                  : round.round_name
                                      .replace(/[0-9]/g, "")
                                      .replace("s", "")
                              }}
                              <!-- {{
                                round.round_name
                              }} -->
                              {{
                                race.ce_events_id ||
                                round.round_name == "Final 1"
                                  ? ""
                                  : race.race_index + 1
                              }}
                            </caption>
                            <thead>
                              <tr>
                                <th width="35px">Pl.</th>
                                <th width="35px">Ln.</th>
                                <th>{{ isTeamEvent ? "Team" : "Athlete" }}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody class="tournament-bracket__content">
                              <tr
                                v-for="(lane, laneIndex) in race.lanes"
                                :key="`lane_${laneIndex}`"
                                class="tournament-bracket__team"
                                v-if="
                                  lane.events_id == selectedEvent.id &&
                                    (lane.checked_in ||
                                      (competition.preDrawnEvents &&
                                        !lane.scratched))
                                "
                              >
                                <td class="tournament-bracket__score">
                                  <span
                                    class="tournament-bracket__number"
                                    style="font-size: 14px; font-weight: bold"
                                  >
                                    {{
                                      lane.eventPlacing &&
                                      !lane.placing.includes("D")
                                        ? lane.eventPlacing
                                          ? ordinal_suffix_of(lane.eventPlacing)
                                          : "TBA"
                                        : lane.placing
                                        ? ordinal_suffix_of(lane.placing)
                                        : "TBA"
                                    }}
                                  </span>
                                </td>
                                <td class="tournament-bracket__score">
                                  <span
                                    class="tournament-bracket__number"
                                    style="
                                      font-size: 14px;
                                      font-weight: bold;
                                      margin-left: 5px;
                                    "
                                  >
                                    {{ lane.lane_no }}
                                  </span>
                                </td>

                                <td class="tournament-bracket__country">
                                  <div class="row">
                                    <q-img
                                      :src="
                                        lane.capUrl
                                          ? lane.capUrl
                                          : 'https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png'
                                      "
                                      class="clubCap"
                                      contain
                                    ></q-img>
                                    <div
                                      @click="
                                        viewTeam(
                                          lane,
                                          round.generatedFromNextProgression
                                        )
                                      "
                                      class="col q-ml-sm"
                                    >
                                      <b v-if="!lane.team_name">
                                        {{ lane.firstName }} {{ lane.lastName }}
                                      </b>
                                      <b v-else>{{ lane.team_name }}</b> <br />
                                      <span
                                        class="tournament-bracket__number"
                                        style="font-size: 10px"
                                      >
                                        <b>{{ lane.association_abbr }}</b>
                                        <q-icon
                                          v-if="lane.team_name"
                                          name="mdi-information-variant"
                                          size="12px"
                                        ></q-icon>

                                        {{ lane.team_name ? "View Team" : "" }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {{ lane.master_time }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </q-scroll-area>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="viewTeamDialog" persistent max-width="600px">
      <q-card v-if="viewTeamDialog" tile style="width: 600px; max-width: 600px">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Team {{ selectedTeam.team_name }}
            </div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="viewTeamDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <div class="row q-pa-md">
            <div class="col-12 q-py-sm">
              <b style="font-size: 16px">Team Members</b>
            </div>
            <div
              v-for="(member, index) in selectedTeam.members &&
              selectedTeam.members.length > 0
                ? selectedTeam.members
                : JSON.parse(selectedTeam.teamMembersRaced)"
              :key="`teamMembers_${index}`"
              class="col-12"
              style="font-size: 14px"
            >
              <div class="row">
                <div
                  class="col-auto q-pr-sm"
                  v-if="
                    selectedEvent.teamsRaceEvent == 1 &&
                      selectedTeam.teamMembersPlacings
                  "
                >
                  <b
                    >{{
                      ordinal_suffix_of(
                        JSON.parse(selectedTeam.teamMembersPlacings)[
                          member.associationsMembers_id
                        ]
                      )
                    }}
                    -
                  </b>
                </div>
                <div class="col">
                  <b>{{ member.firstName }} {{ member.lastName }}</b> -
                  {{ member.playerLabel }}
                </div>
              </div>
            </div>

            <div class="col-12" v-if="selectedTeam.omegaResults">
              <div class="row">
                <div class="col-12 q-py-sm" v-if="selectedTeam.omegaResults">
                  <b style="font-size: 16px">Lap Times</b>
                </div>

                <div
                  class="col-12"
                  v-for="(time, index) in JSON.parse(selectedTeam.omegaResults)
                    .lap_times"
                  :key="`lap_time${index}`"
                >
                  <div class="row">
                    <div class="col-auto q-pr-sm">
                      <b>Lap {{ index + 1 }}:</b>
                    </div>
                    <div class="col">
                      {{ time }}
                    </div>
                  </div>
                </div>
                <div v-if="selectedTeam.omegaResults" class="col-12">
                  <div class="row">
                    <div class="col-auto q-pr-sm">
                      <b
                        >Lap
                        {{
                          JSON.parse(selectedTeam.omegaResults).lap_times
                            .length + 1
                        }}:</b
                      >
                    </div>
                    <div class="col">
                      {{
                        JSON.parse(selectedTeam.omegaResults).finish_pad_time
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-12"
              v-else-if="
                eventResultByTimesDict &&
                  eventResultByTimesDict[selectedTeam.participant_id]
              "
            >
              <div class="row">
                <div
                  class="col-12 q-py-sm"
                  v-if="eventResultByTimesDict[selectedTeam.participant_id]"
                >
                  <b style="font-size: 16px">Lap Times</b>
                </div>

                <div
                  class="col-12"
                  v-for="(time, index) in JSON.parse(
                    eventResultByTimesDict[selectedTeam.participant_id]
                  ).lap_times"
                  :key="`lap_time${index}`"
                >
                  <div class="row">
                    <div class="col-auto q-pr-sm">
                      <b>Lap {{ index + 1 }}:</b>
                    </div>
                    <div class="col">
                      {{ time }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="eventResultByTimesDict[selectedTeam.participant_id]"
                  class="col-12"
                >
                  <div class="row">
                    <div class="col-auto q-pr-sm">
                      <b
                        >Lap
                        {{
                          JSON.parse(
                            eventResultByTimesDict[selectedTeam.participant_id]
                          ).lap_times.length + 1
                        }}:</b
                      >
                    </div>
                    <div class="col">
                      {{
                        JSON.parse(
                          eventResultByTimesDict[selectedTeam.participant_id]
                        ).finish_pad_time
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import athleteAndAssociationSearch from "../components/generalComponents/athleteAndAssociationSearch/athleteAndAssociationSearch";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";

import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: { datatable, athleteAndAssociationSearch, autocomplete },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      competition: "competitions/current",
      competitionLoading: "competition/currentLoading",
      overallPoints: "liveResults/overallPoints",
      overallPointsLoading: "liveResults/overallPointsLoading",
      overallMedals: "liveResults/overallMedals",
      overallMedalsLoading: "liveResults/overallMedalsLoading",
      event: "liveResults/currentEventBrackets",
      eventLoading: "liveResults/currentEventBracketsLoading",
      eventResultByTimesDict: "liveResults/eventResultByTimesDict",
      events: "events/listForWaves",
      eventsLoading: "events/listForWavesLoading",
      athleteAndAssociationList: "liveResults/athleteAndAssociationList",
      athleteAndAssociationListLoading:
        "liveResults/athleteAndAssociationListLoading",
      divisions: "divisions/listForCompetition"
    }),
    eventsFiltered: function() {
      return this.events.filter(e => {
        if (this.filter.search) {
          let val = e.event_name.toLowerCase();
          let matchFound =
            val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1;
          if (matchFound != true) {
            return false;
          }
        }
        if (!this.filter.registration && e.currentStep == 0) {
          return false;
        }
        if (!this.filter.drawingLanes && e.currentStep == 1) {
          return false;
        }
        if (!this.filter.eventInProgress && e.currentStep == 2) {
          return false;
        }
        if (!this.filter.finished && e.currentStep == 3) {
          return false;
        }

        if (this.stepFilter !== null && this.stepFilter != e.currentStep) {
          if (this.stepFilter != 0 || e.currentStep != 1) {
            return false;
          }
        }

        if (
          this.filter.division_id &&
          this.filter.division_id != e.division_id
        ) {
          return false;
        }

        return true;
      });
    }
  },
  data: () => ({
    isTeamEvent: null,
    tab: "eventBrackets",

    selectedEvent: null,
    eventColumns: [
      {
        name: "eventName",
        label: "Event",
        align: "left",
        field: "event_name",
        // style:
        //   "min-width: 150px;max-width: 150px;width: 150px;white-space: normal !important;",
        sortable: true
      }
    ],

    // Step Filter
    stepFilter: null,

    // OverALl Points
    overallPointsFilter: {
      search: ""
    },
    overAllPointsColumn: [
      {
        name: "rank",
        label: "Rank",
        align: "left",
        field: "rank",
        style:
          "min-width: 40px;max-width: 40px;width: 40px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "association_abbr",
        label: "Club",
        align: "left",
        field: "association_abbr",
        style:
          "min-width: 200px;max-width: 200px;width: 200px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "points",
        label: "Points",
        align: "left",
        field: "points",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "1",
        label: "1st",
        align: "left",
        field: "1",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "2",
        label: "2nd",
        align: "left",
        field: "2",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "3",
        label: "3rd",
        align: "left",
        field: "3",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "4",
        label: "4th",
        align: "left",
        field: "4",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "5",
        label: "5th",
        align: "left",
        field: "5",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "6",
        label: "6th",
        align: "left",
        field: "6",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      }
    ],

    // OverALl Medals
    overallMedalsFilter: {
      search: ""
    },
    overAllMedalsColumn: [
      {
        name: "rank",
        label: "Rank",
        align: "left",
        field: "rank",
        style:
          "min-width: 40px;max-width: 40px;width: 40px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "association_abbr",
        label: "Club",
        align: "left",
        field: "association_abbr",
        style:
          "min-width: 200px;max-width: 200px;width: 200px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "medals",
        label: "Medals",
        align: "left",
        field: "medals",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "1",
        label: "1st",
        align: "left",
        field: "1",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "2",
        label: "2nd",
        align: "left",
        field: "2",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "3",
        label: "3rd",
        align: "left",
        field: "3",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "4",
        label: "4th",
        align: "left",
        field: "4",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "5",
        label: "5th",
        align: "left",
        field: "5",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      },
      {
        name: "6",
        label: "6th",
        align: "left",
        field: "6",
        style:
          "min-width: 60px;max-width: 60px;width: 60px;white-space: normal !important;",
        sortable: true
      }
    ],

    filter: {
      search: "",
      registration: true,
      drawingLanes: true,
      eventInProgress: true,
      finished: true,
      division_id: null
    },

    viewTeamDialog: false,
    selectedTeam: null,

    generatedFromNextProgression: 0,

    //  Filtered Association or Athlete
    selectedAthleteOrAssociation_id: null,
    selectedAthleteOrAssociation: null
  }),
  watch: {
    selectedEvent: function() {
      if (this.selectedEvent) {
        this.$store.dispatch("liveResults/eventBrackets", {
          events_id: this.selectedEvent.id
        });
      }
    },
    event: function() {
      this.initBrackets();
    },
    selectedAthleteOrAssociation: function() {
      if (this.selectedAthleteOrAssociation) {
        this.$store.dispatch("events/loadForCompetition", {
          competitions_id: this.$route.params.competitions_id,
          search_id: this.selectedAthleteOrAssociation.id,
          type: this.selectedAthleteOrAssociation.type
        });
      } else {
        this.$store.dispatch("events/loadForCompetition", {
          competitions_id: this.$route.params.competitions_id
        });
      }
    }
  },
  mounted() {
    this.$store.dispatch(
      "competitions/loadByID",
      this.$route.params.competitions_id
    );
    this.$store.dispatch("liveResults/overallPoints", {
      competitions_id: this.$route.params.competitions_id
    });
    this.$store.dispatch("liveResults/overallMedals", {
      competitions_id: this.$route.params.competitions_id
    });

    this.$store.dispatch("events/loadForCompetition", {
      competitions_id: this.$route.params.competitions_id
    });
    this.$store.dispatch(
      "liveResults/loadAllAthleteAndAssociations",
      this.$route.params.competitions_id
    );
    this.$store.dispatch(
      "divisions/loadForCompetition",
      this.$route.params.competitions_id
    );
  },
  methods: {
    initBrackets() {
      if (this.event && this.event.brackets.length > 0) {
        this.isTeamEvent =
          JSON.parse(this.event.brackets[0].playerLabels).length > 1;
      }
    },
    handleDoubleClickEvents(row) {
      this.selectedEvent = row;
    },
    ordinal_suffix_of(i) {
      if (isNaN(i)) return i;
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },

    // Overall Points
    handleDoubleClickOverallPoints(row) {
      console.log(row);
    },

    handleDoubleClickOverallMedals(row) {
      console.log(row);
    },

    eventProgressionColor(value) {
      switch (value) {
        case 0:
          return "primary";
        case 1:
          return "primary";
        case 2:
          return "orange";

        case 3:
          return "positive";

        default:
          return "blue-grey";
      }
    },
    viewTeam(lane, generatedFromNextProgression) {
      if (lane.team_name) {
        this.selectedTeam = lane;
        this.generatedFromNextProgression = generatedFromNextProgression;
        this.viewTeamDialog = true;
      }
    },
    filterAthleteAssociation(val) {
      this.selectedAthleteOrAssociation_id = val;
      this.selectedAthleteOrAssociation = this.athleteAndAssociationList.find(
        a => a.id == val
      );
      console.log(val);
    }
  }
};
</script>

<style lang="scss">
.container {
  width: 90%;
  min-width: 18em;
  margin: 20px auto;

  h1,
  h2 {
    text-align: center;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.5em;
  }

  h2 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 2em;
  }

  //
  // TOURNAMENT BRACKET
  // ---------------------------
  .tournament-bracket {
    display: flex;
    flex-direction: column;

    @media (min-width: $breakpoint-sm) {
      flex-direction: row;
    }
  }

  .tournament-bracket__round {
    display: block;
    margin-left: -3px;
    flex: 1;
  }

  .tournament-bracket__round-title {
    color: #9e9e9e;
    font-size: 0.95rem;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0.5em;
  }

  .tournament-bracket__list {
    display: flex;
    flex-direction: column;
    flex-flow: row wrap;
    justify-content: center;
    border-bottom: 1px dashed #e5e5e5;
    padding-bottom: 2em;
    margin-bottom: 2em;
    padding-inline-start: 0px;
    transition: padding 0.2s ease-in-out, margin 0.2s ease-in-out;

    @media (max-width: $breakpoint-xs) {
      padding-bottom: 1em;
      margin-bottom: 1em;
    }

    @media (min-width: $breakpoint-sm) {
      margin-bottom: 0;
      padding-bottom: 0;
      border-right: 1px dashed #e5e5e5;
      border-bottom: 0;
    }

    .tournament-bracket__round:last-child & {
      border: 0;
    }
  }

  .tournament-bracket__item {
    display: flex;
    flex: 0 1 auto;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    padding: 2% 0;
    width: 48%;
    transition: padding 0.2s linear;

    &:nth-child(odd) {
      margin-right: 2%;
    }

    &:nth-child(even) {
      margin-left: 2%;
    }

    &::after {
      transition: width 0.2s linear;
    }

    @media (max-width: $breakpoint-xs) {
      width: 100%;

      &:nth-child(odd),
      &:nth-child(even) {
        margin-left: 0;
        margin-right: 0;
      }
    }

    @media (min-width: $breakpoint-sm) {
      padding: 0.5em 1em;
      // flex-grow: 2;
      width: 100%;

      &:nth-child(odd),
      &:nth-child(even) {
        margin: 0;
      }

      &::after {
        position: absolute;
        right: 0;
        content: "";
        display: block;
        width: 1em;
        height: 45%;
      }

      &:nth-child(odd)::after {
        & {
          border-top-right-radius: 0.6em;
        }
      }

      &:nth-child(even)::after {
        & {
          border-bottom-right-radius: 0.6em;
        }
      }
      .tournament-bracket__round:first-child & {
        padding-left: 0;
      }
      .tournament-bracket__round:last-child & {
        padding-right: 0;

        &::after {
          display: none;
        }
      }
    }

    @media (min-width: $breakpoint-lg) {
      padding: 0.5em 1.5em;

      &::after {
        width: 1.5em;
      }
    }
  }

  .tournament-bracket__match {
    display: flex;
    width: 100%;
    background-color: #ffffff;
    padding: 1em;
    border: 1px solid transparent;
    border-radius: 0.1em;
    box-shadow: 0 2px 0 0 #e5e5e5;
    outline: none;
    cursor: pointer;
    transition: padding 0.2s ease-in-out, border 0.2s linear;

    &:focus {
      border-color: #2196f3;
    }

    &::before,
    &::after {
      transition: all 0.2s linear;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 0.75em 0.5em;
    }

    @media (min-width: $breakpoint-sm) {
      &::before,
      &::after {
        position: absolute;
        left: 0;
        z-index: 1;
        content: "";
        display: block;
        width: 1em;
        height: 10%;
      }

      &::before {
      }

      &::after {
      }
    }

    @media (min-width: $breakpoint-lg) {
      &::before,
      &::after {
        width: 1.5em;
      }

      &::before {
        transform: translate(0, 1px);
      }

      &::after {
        transform: translate(0, -1px);
      }
    }
  }

  .tournament-bracket__round:last-child .tournament-bracket__match {
    &::before,
    &::after {
      border-left: 0;
    }

    &::before {
      border-bottom-left-radius: 0;
    }

    &::after {
      display: none;
    }
  }

  .tournament-bracket__round:first-child .tournament-bracket__match {
    &::before,
    &::after {
      display: none;
    }
  }

  .tournament-bracket__table {
    width: 100%;

    .clubCap {
      width: 40px;
    }
  }

  .tournament-bracket__caption {
    font-size: 0.8rem;
    color: #bdbdbd;
    font-weight: 300;
    padding-bottom: 0.75em;
  }

  .singlePassthrough::after {
    border-radius: 0 !important;
    border-right: 0;
    // border-top: 0 !important;
  }

  .notBracket::after {
    border-radius: 0 !important;
    border-right: 0 !important;
    border-top: 0 !important;
    border-bottom: 0 !important;
  }

  .notBracket {
    .tournament-bracket__match {
      &::before {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-bottom: 0 !important;
      }

      &::after {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-top: 0 !important;
      }
    }
  }

  .bracketStart {
    .tournament-bracket__match {
      &::before {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-bottom: 0 !important;
      }

      &::after {
        border-radius: 0 !important;
        border-left: 0 !important;
        border-top: 0 !important;
      }
    }
  }

  .finalBracket::after {
    border-radius: 0 !important;
    border: 0 !important;
  }
  .noMoreEvents {
    border-right: 0;
  }
}
</style>
